import styled from "styled-components";
import {McqItemContainer,McqToolbar} from "static/styled/custom.styled"
import {ActivityInputField, ActivityDescription} from "@c/activity-view/activity-creation-form/ActivityCreationForm.styled";
export const Container=styled.div`

`;

export const SeriesPopUpContainer=styled.div`
display:flex;
flex-flow:row wrap;
justify-content:space-between;
width:700px;
overflow:hidden;
height:100%;
`;

export const SeriesListMainContainer=styled.div`
 width:50%;
 //padding:0px 18px;
 position:relative;
  border-right:solid 1px rgba(151,151,151,0.2);`;

export const SeriesCreatorContainer=styled.div`
  width:50%;
 `;

export const SeriesListContainer=styled.div`
 overflow-y:auto;
 min-height:330px;
 /* max-height:calc( 100vh - 340px); */
 overflow-x: hidden;
 `;

export const SeriesCreatorListContainer= SeriesListContainer.extend`
display: flex;
flex-direction: column;
gap: 10px;
align-items: center;
margin-bottom: 1rem;
`;

export const SeriesItem=McqItemContainer.extend`
   width:100%;
   position:relative;
   display:flex;


   align-items:center;
   cursor:pointer;
    border-radius:10px;
   justify-content:center;
   height:64px;
   padding:6px 8px;
    background:url(${props=>props.bg?props.bg:''});
    background-repeat:no-repeat;
    background-size:cover;
   `;
export const SeriesToolbar=McqToolbar.extend`
    top:auto;
    bottom:10px;
    right:10px;`;

export const TitleInputField=ActivityInputField.extend`
margin:0px;
padding:10px;
border : 1px solid grey;
border-radius : 10px;
height: auto;
margin-bottom: 10px;
`
;

export const DescriptionInputField=ActivityDescription.extend`
border : 1px solid grey;
border-radius : 10px;
height: auto;
padding: 10px;
`

export const UploadSeriesImageButton=styled.button`
outline:none;
border:none;
 display-flex;
 justify-content:center;
 width:100%;
 flex-flow:column no-wrap;
 background-color:transparent;
 align-items:center;
 position:relative;
 i
 {
 font-size:36px;
 color:rgba(67, 38, 102,0.2);
 }

 div
 {
bottom:8px;
left:0;
text-align:center;
display:inline-block;
position:absolute;
width:100%;
 font-size:var(--sm-font-size);
  color: #432666;
 }
 `;

 export const SeriesStoryItemContainer = styled.div`
    padding: 10px;
    borderBottom: 1px solid #ddd;
    background: #f7f4f4;
    cursor: move;
    display : flex;
    gap: 10px;
    border-radius: 10px;
    align-items: flex-start;
    margin-bottom: 10px;
    -webkit-user-select: none; /* Chrome, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE/Edge */
    user-select: none;         /* Standard */
 `;

 export const SeriesStoryItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
 `